import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideTranslateService } from '@ngx-translate/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { loadingInterceptor } from './interceptors/loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      // Ordine: auth aggiunge il token; error gestisce 401/errori; loading
      // (il più interno) apre/chiude il loader. Sulla risposta l'ordine è
      // inverso → loading chiude prima che error mostri l'eventuale dialog.
      withInterceptors([authInterceptor, errorInterceptor, loadingInterceptor]),
    ),
    provideTranslateService({
      fallbackLang: 'en',
      lang: 'en',
    }),
  ],
};
